import { defaulLangTextValidation, defaultTTranslate, MEASURE, SORTING_DIRECTION } from 'src/constants/main';
import { DELIVERY_ORDER_TYPE, IProductV4, PRODUCTS_SORT_COLUMN, PRODUCT_ORDER_TYPE, PRODUCT_TYPE } from 'src/types/product';
import { IItemsFilters, IItemValidation, IOrderTypeOption } from 'src/view/screens/MenuManagementScreen/screens/ItemsScreen/types/items';

export const defaultItem: IProductV4 = {
  id: 0,
  external_id: undefined,
  name: defaultTTranslate,
  description: defaultTTranslate,
  order_type: DELIVERY_ORDER_TYPE.ALL,
  price: '',
  calories: null,
  weight: '',
  unit: MEASURE.NULL,
  //
  type: PRODUCT_TYPE.PRODUCT,
  //
  image: '',
  images: undefined,
  //
  min_quantity: 1,
  is_donation: 0,
  is_favorite: 0,
  sort: 0,
  earn: undefined,
  redeem: undefined,
  //
  is_modifiers: 0,
  modifiers: [],
  //
  is_size: 0,
  size: null,
  sizes: [],
  //
  is_exclusions: 0,
  exclusions: [],
  //
  category: undefined,
  upsales_items: [],
  //
  out_of_stock: 0,
  status: 1,
  is_delete: 0,
  //
  is_draft: true,
  apply_item_price_to_all: 0,
  apply_availability_to_all: 0,
  allergens: [],
  nutrients: null,
  nutrient: null,
};

export const defaultItemsFilters: IItemsFilters = {
  search: '',
  availability: undefined,
  category: undefined,
  sort_field: PRODUCTS_SORT_COLUMN.NAME,
  sort_dir: SORTING_DIRECTION.ASCENDING,
};

export const defaultItemValidation: IItemValidation = {
  valid: true,
  images: true,
  name: defaulLangTextValidation,
  orderType: true,
  category: true,
  calories: {
    state: true,
  },
  price: {
    state: true,
  },
  modifiers: [],
  sizes: [],
};

export const orderTypeCheckboxOptions: IOrderTypeOption[] = [
  { value: PRODUCT_ORDER_TYPE.DELIVERY, label: 'txt_delivery' },
  { value: PRODUCT_ORDER_TYPE.PICKUP_CURBSIDE, label: 'pickup_curbside' },
  { value: PRODUCT_ORDER_TYPE.DINEIN, label: 'dine_in' },
];

export const productTypeErrorMessages = {
  [PRODUCT_ORDER_TYPE.DELIVERY]: 'order_type_not_supported_for_delivery',
  [PRODUCT_ORDER_TYPE.PICKUP_CURBSIDE]: 'order_type_not_supported_for_pickupcurbside',
  [PRODUCT_ORDER_TYPE.DINEIN]: 'order_type_not_supported_for_dinein',
};
